




































import { STATUSES, TYPES } from "@/constants/risk_profile"
import TransitionMixins from "@/mixins/TransitionMixins"
import _ from "lodash"
import { Component, Mixins, Model, Prop, Watch } from "vue-property-decorator"
import { mapState } from "vuex"
import QListItemExpand from "../QListItemExpand.vue"

@Component({
  components: {
    QListItemExpand
  },
  computed: {
    ...mapState({
      loading: "loading"
    }),
    ...mapState("Auth", {
      activeBusiness: "activeBusiness"
    }),
    ...mapState("RiskProfile", {
      riskProfile: "riskProfile",
      searchOptions: "searchOptions",
      riskProfileList: "list"
    })
  }
})
export default class RiskProfileSelect extends Mixins(TransitionMixins) {
  @Model("change") selected!: string

  @Prop() readonly businessOid!: string

  search = ""

  items = []
  cachedQuery!: string

  searchOptions!: {
    query: string;
    itemsPerPage: number;
  }

  riskProfile!: Model
  riskProfileList!: Model[]

  @Watch("searchOptions.query")
  watchQuery(newVal) {
    const lowerRiskProfileName = _.toLower(
      this.riskProfile?.custom_job_role_name || this.riskProfile?.name
    )
    const lowerNewVal = _.toLower(newVal)
    // reset selected if the new query string does not included in the selected risk profile name
    if (!lowerRiskProfileName.includes(lowerNewVal)) {
      this.$emit("change", "")
    }
  }

  get options() {
    return this.searchOptions
  }

  set options(value) {
    this.$store.commit("RiskProfile/SET_SEARCH_OPTIONS", value)
  }

  get isSelected() {
    return !!this.selected
  }

  async beforeMount() {
    if (this.selected && !this.riskProfile?.gid) {
      await this.$store.dispatch(
        "RiskProfile/fetchFullStructure",
        this.selected
      )
      this.searchOptions.query = this.riskProfile?.custom_job_role_name ?? ""
    }
  }

  async setSelection(item) {
    if (item.object_id !== this.selected) {
      if (this.riskProfile?.object_id !== item.object_id) {
        await this.$store.dispatch(
          "RiskProfile/fetchFullStructure",
          item.object_id
        )
      }
      this.$emit("change", item.object_id)
    } else {
      this.$emit("change", "")
    }
  }

  created() {
    this.cachedQuery = this.searchOptions.query
  }

  handleFetchJobList(query, page, itemsPerPage) {
    if (this.riskProfileList && this.options.query === this.cachedQuery) {
      return this.riskProfileList
    }

    let params: Record<string, string> = {
      page: page,
      per_page: itemsPerPage === -1 ? 10 : itemsPerPage,
      sort: "-updated_at",
      business_oid: this.businessOid,
      status: STATUSES.STATUS_PUBLISHED.key,
      type: TYPES.TYPE_STANDARD.key
    }
    if (query.length > 2) {
      this.cachedQuery = query
      params = {
        ...params,
        search_name: query
      }
    }
    return this.$store.dispatch("RiskProfile/fetchList", {
      params
    })
  }

  closeQuery() {
    this.options.query = ""
    this.$emit("change", "")
  }
}
